/**
 * 系统配置模块路由配置
 * 
 * 重要：权限码使用 PermissionCode 常量，与数据库 permission.code 一致
 */
import type { RouteRecordRaw } from 'vue-router'
import { PermissionCode } from '@/constants/permission-codes'
import {
  SystemConfigManagement,
  APIConfigManagement,
  ClientConfigManagement,
  LanguageManagement,
  OrganizationManagement,
  RoleManagement,
  HotWordManagement
} from '@/modules/system/views'
import { UserManagement } from '@/modules/user/views'
import { preloadComponent, AdminComponents } from '@/utils/lazyLoad'

const systemRoutes: RouteRecordRaw[] = [
  {
    path: 'system',
    name: 'System',
    meta: {
      titleKey: 'menu.system',
      title: '系统管理',
      requiresAuth: true,
      // 与 DB permission_code 一致
      permissions: [
        PermissionCode.SYSTEM_USER,
        PermissionCode.SYSTEM_ROLE,
        PermissionCode.SYSTEM_PERMISSION,
        PermissionCode.SYSTEM_ORGANIZATION,
        PermissionCode.SYSTEM_USAGE,
        PermissionCode.SYSTEM_API,
        PermissionCode.SYSTEM_DICTIONARY,
        PermissionCode.SYSTEM_CONFIG
      ],
      icon: 'SettingOutlined'
    },
    children: [
      {
        path: 'user',
        name: 'UserManagement',
        component: UserManagement,
        meta: {
          titleKey: 'menu.userManagement',
          title: '用户管理',
          requiresAuth: true,
          permissions: [PermissionCode.SYSTEM_USER],
          breadcrumb: true
        }
      },
      {
        path: 'organization',
        name: 'Organization',
        component: OrganizationManagement,
        meta: {
          titleKey: 'menu.organization',
          title: '组织架构',
          requiresAuth: true,
          permissions: [PermissionCode.SYSTEM_ORGANIZATION],
          breadcrumb: true
        }
      },
      {
        path: 'role',
        name: 'RoleManagement',
        component: RoleManagement,
        meta: {
          titleKey: 'menu.roleManagement',
          title: '角色管理',
          requiresAuth: true,
          permissions: [PermissionCode.SYSTEM_ROLE],
          breadcrumb: true
        }
      },
      {
        path: 'usage',
        name: 'UsageManagement',
        component: () => import('@/modules/usage/views/UsageManagement.vue'),
        meta: {
          titleKey: 'menu.usageManagement',
          title: '用量管理',
          requiresAuth: true,
          permissions: [PermissionCode.SYSTEM_USAGE],
          breadcrumb: true
        }
      },
      {
        path: 'api',
        name: 'ApiManagement',
        component: APIConfigManagement,
        meta: {
          titleKey: 'menu.apiManagement',
          title: 'API管理',
          requiresAuth: true,
          permissions: [PermissionCode.SYSTEM_API],
          breadcrumb: true
        }
      },
      {
        path: 'client-config',
        name: 'ClientConfigManagement',
        component: ClientConfigManagement,
        meta: {
          titleKey: 'menu.clientConfigManagement',
          title: '客户端配置',
          requiresAuth: true,
          permissions: [PermissionCode.SYSTEM_API],
          breadcrumb: true
        }
      },
      {
        path: 'dictionary',
        name: 'Dictionary',
        component: LanguageManagement,
        meta: {
          titleKey: 'menu.dictionary',
          title: '数据字典',
          requiresAuth: true,
          permissions: [PermissionCode.SYSTEM_DICTIONARY],
          breadcrumb: true
        }
      },
      {
        path: 'config',
        name: 'SystemConfig',
        component: SystemConfigManagement,
        meta: {
          titleKey: 'menu.systemConfig',
          title: '系统配置',
          requiresAuth: true,
          permissions: [PermissionCode.SYSTEM_CONFIG],
          breadcrumb: true
        }
      }
    ]
  }
]

export default systemRoutes

